import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { useTranslation } from '../../../app/LanguageContext';

const TemplateStudioGuide = ({ onOpenVariables }) => {
  const { translate } = useTranslation();

  return (
    <Alert
      severity="info"
      icon={<MenuBookOutlinedIcon fontSize="small" />}
      sx={{ mb: 2, alignItems: 'flex-start' }}
      action={
        <Button size="small" color="inherit" onClick={onOpenVariables} sx={{ whiteSpace: 'nowrap', mt: 0.25 }}>
          {translate('catalog.templates.variables_open')}
        </Button>
      }
    >
      <Box>
        <Typography variant="body2" fontWeight={600} gutterBottom>
          {translate('catalog.templates.guide_compact_title')}
        </Typography>
        <Typography variant="body2" component="div">
          {translate('catalog.templates.guide_compact_body')}
        </Typography>
      </Box>
    </Alert>
  );
};

export default TemplateStudioGuide;
